// extracted by mini-css-extract-plugin
module.exports = {"root":"OrderHistory_root__2VB1W","reason":"OrderHistory_reason__3SAzs"};